import { Link, useLocation } from "react-router-dom";
import { Layers, Sparkles, UtensilsCrossed, Package, SlidersHorizontal } from "lucide-react";

const TABS = [
  { path: "/panel/catalogo",          label: "Todo el catálogo",  icon: Layers,             testid: "subnav-catalogo" },
  { path: "/panel/experiencias",      label: "Experiencias",       icon: Sparkles,           testid: "subnav-experiencias" },
  { path: "/panel/menus",             label: "Menús",              icon: UtensilsCrossed,    testid: "subnav-menus" },
  { path: "/panel/servicios-rapidos", label: "Servicios y extras", icon: Package,            testid: "subnav-servicios" },
  { path: "/panel/cotizador-config",  label: "Config. cotizador",  icon: SlidersHorizontal,  testid: "subnav-cotizador-config" },
];

/**
 * CatalogoSubnav — Barra de pestañas horizontal para navegar entre las 5 pantallas
 * del módulo Catálogo (Catálogo general, Experiencias, Menús, Servicios/Extras, Config).
 * Se coloca al inicio de cada página del módulo para dar contexto y navegación rápida.
 */
const CatalogoSubnav = () => {
  const location = useLocation();
  const activePath = TABS.find(t => location.pathname === t.path)?.path;

  return (
    <div className="eo-card p-1.5 mb-5 flex items-center gap-1 overflow-x-auto" data-testid="catalogo-subnav">
      {TABS.map(tab => {
        const Icon = tab.icon;
        const active = activePath === tab.path;
        return (
          <Link
            key={tab.path}
            to={tab.path}
            className="flex items-center gap-1.5 px-3 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition"
            style={{
              background: active ? "var(--brand-primary)" : "transparent",
              color: active ? "#fff" : "var(--brand-text-muted)",
            }}
            data-testid={tab.testid}
          >
            <Icon className="w-4 h-4" />
            <span>{tab.label}</span>
          </Link>
        );
      })}
    </div>
  );
};

export default CatalogoSubnav;
